import * as React from "react";
import GoogleMapsProvider from "@route-planner/components/GoogleMapsProvider";
import RoutePlanner from "@route-planner/components/RoutePlanner";

const Component = (props) => {
  return (
    <GoogleMapsProvider apiKey={process.env.REACT_APP_GOOGLE_KEY}>
      <RoutePlanner />
    </GoogleMapsProvider>
  );
};

const page = {
  routeProps: {
    path: "MyRoutes",
    component: Component,
  },
  name: "My Routes",
  label: "My Routes",
  title: "My Routes",
  showOnMenu: true,
};

export default page;
